module.exports = __webpack_public_path__ + "static/media/page06_front.4ea864ac.gif";